import { render, staticRenderFns } from "./PoolSelector.vue?vue&type=template&id=67f2b472&"
import script from "./PoolSelector.vue?vue&type=script&lang=js&"
export * from "./PoolSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports